"use client";

import { TolgeeProvider } from "@tolgee/react";
import type { ReactNode } from "react";
import { readLocale } from "#/lib/locale.ts";
import { TOLGEE_STATIC_DATA, tolgee } from "./tolgee-instance";

export function TolgeeProviderWrapper({ children }: { children: ReactNode }) {
	return (
		<TolgeeProvider
			tolgee={tolgee}
			fallback={null}
			// ssr: 첫 렌더에서 staticData+언어를 동기 적용해 isLoaded()를 즉시
			// true로 만든다. 없으면 서버(셸 프리렌더)가 fallback(null)만 렌더해
			// <html> 전체가 빈 문서가 되고, 클라이언트 콜드 로드도 한 프레임
			// null을 그린다. 서버의 readLocale()은 "en"(가드) — 결정적.
			ssr={{ language: readLocale(), staticData: TOLGEE_STATIC_DATA }}
		>
			{children}
		</TolgeeProvider>
	);
}
